import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { Link, useNavigate } from 'react-router-dom'

import { APP_ROUTES } from '@/util/appRoutes'
import { numberFormat } from '@/util/formatters/numbers'

import { Translation } from '../i18n/Translation'

const BuyoutContent: FC<{
  assetName: string
  buyoutPrice: number
  isLoading: boolean
  isBoughtOut: boolean
  buyOut: () => void
}> = ({ buyOut, assetName, buyoutPrice, isLoading, isBoughtOut }) => {
  const navigate = useNavigate()

  if (isLoading) {
    return <div className="loader" />
  }

  if (isBoughtOut) {
    return (
      <>
        <p>
          <Translation id="Din telefon blir nå kjøpt ut" buyoutPrice={numberFormat(buyoutPrice)} />
        </p>
        <p>
          <Translation id="Du kan nå bestille ny telefon" />
        </p>
        <p>
          <Link to={APP_ROUTES.shop}>
            <Translation id="Gå til telefonbestilling" />
          </Link>
        </p>
      </>
    )
  }

  return (
    <>
      <p>
        <Translation
          id="Du kan kjøpe ut din telefon"
          buyoutPrice={numberFormat(buyoutPrice)}
          assetName={assetName}
        />
      </p>
      <p>
        <Translation id="Velger du å kjøpe ut telefonen vil beløpet bli trukket" />
      </p>

      <div className="options">
        <Button onClick={buyOut}>
          <Translation id="Kjøp ut telefon" />
        </Button>

        <Button onClick={() => navigate(APP_ROUTES.shop)}>
          <Translation id="Avbryt" />
        </Button>
      </div>
    </>
  )
}

export default BuyoutContent
